import React, { useState } from "react";
import { toast } from "react-toastify";
import { logo_blue } from "../../../assets";
import { Button, Form, Input, Label, StyledImgUpload, Textarea } from "../../../styles";
import { ICON_PEN } from "../../../utils/icons";
import SettingsWrapper from "../../../layout/SettingsWrapper";
import Api from "../../../api/axios";
import { useUserContext } from "../../../context/user_context";
import { convertPhoto } from "../../../utils/helpers";

function BusinessProfile() {

  const [issending, setissending] = useState(false);

  const { businessData, getBusinessData, usertoken } = useUserContext();
  // console.log(businessData);
  const {
    btoken,
    name
    , bmail
    , address
    , phone
    , no_workers
    , description
    , bankname
    , accountname
    , accountnumber
    , vat_rate
    , tax_rate
    , logo
    , real_date
  } = businessData;


  const [formField, setformField] = useState({
    name
    , bmail
    , address
    , phone
    , no_workers
    , description
    , bankname
    , accountname
    , accountnumber
    , vat_rate
    , tax_rate
    , photo: logo
  });

  // Form Fields
  function handleChange(e) {
    if (e.target.name === 'photo') {
      setformField((inputs) => ({
        ...inputs,
        [e.target.name]: e.target.files[0],
      }));
    } else {
      setformField((inputs) => ({
        ...inputs,
        [e.target.name]: e.target.value,
      }));
    }
  }
  // Form Field

  // Edit Function 
  const [editData, seteditData] = useState(true);
  function onEdit() {
    seteditData(false);
    if (editData === true) {
      toast.success('You can now edit...');
    } else { }
  }
  // Edit Function 

  function submitFn(e) {
    e.preventDefault();
    if ((formField.name
      && formField.bmail
      && formField.address
      && formField.phone
      && formField.no_workers
      && formField.description
      // && formField.bankname
      // && formField.accountname
      // && formField.accountnumber
      // && formField.vat_rate
      // && formField.tax_rate
      // && formField.logo

    )) {
      setissending(true);
      const data = {
        name: formField.name,
        bmail: formField.bmail,
        address: formField.address,
        phone: formField.phone,
        no_workers: formField.no_workers,
        description: formField.description,
        bankname: formField.bankname,
        accountname: formField.accountname,
        accountnumber: formField.accountnumber,
        vat_rate: formField.vat_rate,
        tax_rate: formField.tax_rate,
        logo: formField.photo,
        btoken, usertoken
      };
      Api.post(`/updateBusiness`, data)
        .then((res) => {
          if (res.success === false) {
            toast.warn(res.message);
            setissending(false);
          } else {
            setissending(false);
            seteditData(true);
            getBusinessData();
            toast.success(res.message);
          }
        })
        .catch((error) => {
          setissending(false);
        });
    } else {
      setissending(false);
      toast.warn("Empty Fields !!!");
    }
  }

  return (
    <>

      <SettingsWrapper
        title="BUSINESS PROFILE"
        onEdit={onEdit}
      >
        <div className="d-flex flex-wrap gap-2 mt-4 ">
          <h6 className="pry-text sec fit-content br-sm p-2 mr-3">
            Created:  <span className="fw-bold"> {real_date} </span>
          </h6>
          <h6 className="pry-text sec fit-content br-sm p-2">
            Business ID: <span className="fw-bold"> {btoken}</span>
          </h6>
        </div>

        <Form onSubmit={(e) => submitFn(e)}>

          <div className="row justify-content-center">
            <div className="col-md-6 ">
              <StyledImgUpload className="me-auto mb-4">
                <div className="d-flex ml-auto justify-content-center">
                  <div className=" py-4 mb-4" >
                    <img src={formField.photo || logo_blue} alt={'Business Logo'} width="100%" />
                  </div>

                  {
                    !editData &&
                    <>
                      <div className="file-upload">
                        <Input
                          type="file"
                          accept="image/*"
                          onChange={(e) => convertPhoto(e, setformField)}
                        />
                        <span className="pry-text">
                          {ICON_PEN}
                        </span>
                      </div>
                    </>
                  }
                </div>

              </StyledImgUpload>
              <Label> Company Name: </Label>
              <Input
                type="text"
                name="name"
                placeholder="Enter Name"
                onChange={handleChange}
                value={formField.name}
                required
                disabled={editData ? true : false}
              />


              <Label> Company Address: </Label>
              <Input
                type="text"
                name="address"
                placeholder="Enter Address"
                onChange={handleChange}
                value={formField.address}
                required
                disabled={editData ? true : false}
              />


              <Label> Phone Number: </Label>
              <Input
                type="number"
                name="phone"
                placeholder="e.g. 08012345678"
                onChange={handleChange}
                value={formField.phone}
                required
                disabled={editData ? true : false}
              />



              <Label> Number of workers: </Label>
              <Input
                type="number"
                name="no_workers"
                placeholder="Number of Workers"
                onChange={handleChange}
                value={formField.no_workers}
                required
                disabled={editData ? true : false}
              />

            </div>
            <div className="col-md-6 ">

              <Label> Bank Name: </Label>
              <Input
                type="text"
                name="bankname"
                placeholder="Bank Name"
                onChange={handleChange}
                value={formField.bankname}
                disabled={editData ? true : false}
              />
              <Label> Bank Account Number: </Label>
              <Input
                type="number"
                name="accountnumber"
                placeholder="Bank Account Number"
                onChange={handleChange}
                value={formField.accountnumber}
                disabled={editData ? true : false}
              />

              <Label> Back Account Name: </Label>
              <Input
                type="text"
                name="accountname"
                placeholder="Back Account Name"
                onChange={handleChange}
                value={formField.accountname}
                disabled={editData ? true : false}
              />

              <Label> Tax Rate (%): </Label>
              <Input
                type="number"
                name="tax_rate"
                placeholder="Tax Rate"
                onChange={handleChange}
                value={formField.tax_rate}
                disabled={editData ? true : false}
              />

              <Label> VAT Rate (%): </Label>
              <Input
                type="number"
                name="vat_rate"
                placeholder="VAT Rate"
                onChange={handleChange}
                value={formField.vat_rate}
                disabled={editData ? true : false}
              />

              <Label> Store Description: </Label>

              <Textarea
                type="text"
                name='description'
                disabled={editData ? true : false}
                placeholder="Description *"
                onChange={handleChange}
                value={formField.description}
              ></Textarea>
            </div>
            {!editData &&
              <div className="col-md-12 mb-4 mx-auto text-center">
                <Button
                  pry
                  type="submit"
                  disabled={issending}
                  className="btn m-0 w-100"  >
                  {issending ? 'loading...' : "Submit"}
                </Button>
              </div>
            }
          </div>
        </Form>
      </SettingsWrapper>

      {/* {load ? <AppLoader /> : <></>} */}

    </>
  );
}

export default BusinessProfile;
